<evc-modal [showCloseButton]="false"
           [showReduceButton]="false"
           [showBackdrop]="false"
           [maxWidth]="'1000px'"
           [maxHeight]="'800px'"
           (closeModal)="close()">
  <div class="main-container"  modal-content>
    <div class="container license-layout">
      <ng-container *ngIf="isOnPremiseMode; then standaloneLicenseTexts else licenseTexts"></ng-container>
      <evc-nav-button type="tertiary" (click)="close()">{{ 'licenseAgreementDialog.close' | translate }}</evc-nav-button>
    </div>
    <ng-template #standaloneLicenseTexts >
      <!-- For OnPremise Mode license text. -->
      <app-standalone-license-texts class="license-texts"></app-standalone-license-texts>
    </ng-template>
    <ng-template #licenseTexts>
      <!-- For other license text. -->
      <app-license-texts class="license-texts"></app-license-texts>
    </ng-template>
  </div>
</evc-modal>
